import React from 'react';
import StyleSheet from './StyleSheet';
import * as MaterialIcons from 'react-icons/md';
import { LuCircleChevronDown, LuCircleChevronRight } from 'react-icons/lu';

// The Material Community names the app uses, drawn with real icons. Before,
// these were Unicode characters (☑ ☐ ⊕ ⊖), and any other name was a "?".
const aliases = {
  'checkbox-marked': MaterialIcons.MdCheckBox,
  'checkbox-outline': MaterialIcons.MdCheckBox,
  'checkbox-blank-outline': MaterialIcons.MdCheckBoxOutlineBlank,
  'checkbox-blank': MaterialIcons.MdCheckBoxOutlineBlank,
  'chevron-down-circle-outline': LuCircleChevronDown,
  'chevron-forward-circle-outline': LuCircleChevronRight,
  'clear': MaterialIcons.MdClear,
};

const Icon2 = ({ name, size = 24, color = '#000', type = 'FontAwesome', style, onPress, ...props }) => {
  const flatStyle = StyleSheet.flatten ? StyleSheet.flatten(style) : style;

  // A name may also be a react-icons Material name (MdExpandMore)
  const IconComponent = aliases[name] || MaterialIcons[name];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        fontSize: size,
        color,
        cursor: onPress ? 'pointer' : 'default',
        fontWeight: 'normal',
        userSelect: 'none',
        ...flatStyle
      }}
      onClick={onPress}
      {...props}
    >
      {IconComponent ? <IconComponent size={size} color={color} /> : '?'}
    </span>
  );
};

export default Icon2;
